const SGPIcon = (props) => {
  return (
    <svg
      className="overflow-hidden"
      width="100%"
      height="100%"
      viewBox="240 0 360 218"
      stroke="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M507.69 0.75L382.52 217.56H238.6L343.79 35.36C356.16 13.94 379.02 0.75 403.75 0.75H507.69V0.75Z"
        fill="inherit"
      />
      <path
        d="M591.01 0.75L484.77 184.76C473.05 205.05 451.4 217.56 427.96 217.56H405.24L530.42 0.75H591.01Z"
        fill="inherit"
      />
    </svg>
  )
}

export default SGPIcon
